import * as z from "zod";
import { mutator } from "./mutator";

const updateServiceAccountSchema = z.object({
  id: z.string(),
  name: z.string().min(1).max(120).optional(),
  description: z.string().max(500).nullable().optional(),
  disabled: z.boolean().optional(),
});

// Managing an account (rename, re-describe, enable/disable) requires
// service_account:manage on that account. Disabling immediately invalidates
// all of its credentials (verifyApiKey checks the disabled flag).
export const updateServiceAccount = mutator({
  schema: updateServiceAccountSchema,
  resolve: {
    serviceAccount: { kind: "serviceAccount", from: "id" },
  },
  permissions: [
    {
      permission: "service_account:manage",
      scopeId: ({ args }) => args.serviceAccount.id,
    },
  ],
  fn: async ({ tx, args: { serviceAccount, name, description, disabled } }) => {
    const patch: Record<string, unknown> = {
      id: serviceAccount.id,
      updatedAt: Date.now(),
    };
    if (name !== undefined) patch.name = name;
    if (description !== undefined) patch.description = description;
    if (disabled !== undefined) patch.disabled = disabled;
    await tx.mutate.serviceAccounts.update(patch as { id: string });
  },
});
